import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import React, { Fragment } from 'react';
import { displayFormattedDate, getAccountHolderName, getClientConfig, isEmpty } from '../../../generalFunctions';
import dayjs from 'dayjs';
import { FIRM_NAME } from '../../../constants';

const PartywiseRORegister = (props) => {
    let formattedData = [];
    let alreadyFilteredRos = [];
    const { startDate, endDate, accountId } = props.dates;
    const accountName = getAccountHolderName(accountId);

    const formatPartyBillData = (billData) => {
        let stringBillData = "";
        billData.forEach((bill, index) => {
            stringBillData = index === 0 ?
                stringBillData + bill.partyBillId + " " + bill.partyBillAmount
                : stringBillData + "\n" + bill.partyBillId + " " + bill.partyBillAmount;
        });
        return stringBillData;
    }

    const formatPublicationBillData = (billData) => {
        let stringBillData = "";
        billData.forEach((bill, index) => {
            stringBillData = index === 0 ?
                stringBillData + bill.pubBillId + " " + bill.pubBillAmount
                : stringBillData + "\n" + bill.pubBillId + " " + bill.pubBillAmount;
        });
        return stringBillData;
    }

    props.data?.forEach(ro => {
        if (!alreadyFilteredRos.includes(ro.roId)) {
            let roWithSameIds = props.data.filter(r => r.roId === ro.roId);
            let currentRO = { ...roWithSameIds[0] };
            currentRO.partyBills = [];
            currentRO.publicationBills = [];
            let alreadyFilteredPartyBills = [], alreadyFilteredPublicationBills = [];
            roWithSameIds.forEach(filteredRo => {
                if (filteredRo.partyBillId && !alreadyFilteredPartyBills.includes(filteredRo.partyBillId)) {
                    currentRO.partyBills.push({
                        partyBillId: filteredRo.partyBillId,
                        partyBillAmount: filteredRo.partyBillAmount
                    });
                    alreadyFilteredPartyBills.push(filteredRo.partyBillId);
                }
            });
            delete currentRO.partyBillId; delete currentRO.partyBillAmount;
            formattedData.push(currentRO);
            alreadyFilteredRos.push(ro.roId);
        }
    });

    formattedData?.forEach((element, index) => {
        element.srno = index + 1;
        element.sizeCms = element.width ? element.width + " * " + element.height : "Classified";
        element.roDate = !isEmpty(element.roDate) ? moment(element.roDate).format("DD/MM/YYYY") : element.roDate;
        element.publication = element.publicationName;
        element.caption = element.captionName;
        element.dateOfInsertion = !isEmpty(element.dateOfInsertion) && !element.dateOfInsertion.includes(",") ? dayjs(element.dateOfInsertion).format("DD-MM-YYYY") : element.dateOfInsertion.replace(/,/g, " ");
        element.ourBillnAmt = formatPartyBillData(element.partyBills);
    });

    const tableData = {
        columnName: ["Sr", "RO Id", "Size", "Date", "Publication", "Type of Advt", "Release Date", "Our Bill No. & Amt.", "Client Name"],
        column: ["srno", "roId", "sizeCms", "roDate", "publication", "caption", "dateOfInsertion", "ourBillnAmt", "clientName"],
        width: [3, 7, 7, 7, 17, 15, 12, 15, 15],
        data: formattedData
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape" size="A4">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>{`Release Order Register for the period: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)}`}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>A/c Name: {accountName ? accountName : ""}</Text>
            </View>
            <Fragment>
                <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 7, textAlign: "left", alignSelf: "flex-start" }}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, fontSize: 9, paddingRight: 7
                    }}>{c}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 3, textAlign: "left", alignSelf: "flex-start" }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%`, fontSize: 9, paddingRight: 5, paddingBottom: 3 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
        </Page>
    );
}

export default PartywiseRORegister;